/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryUser } from '../../models/inventory-user';

export interface GetUserInventoryRoles$Params {
  id: string;
}

export function getUserInventoryRoles(http: HttpClient, rootUrl: string, params: GetUserInventoryRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InventoryUser>>> {
  const rb = new RequestBuilder(rootUrl, getUserInventoryRoles.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InventoryUser>>;
    })
  );
}

getUserInventoryRoles.PATH = '/admin/users/{id}/inventory-roles';
